import { LoadableBackground } from '@confluence/loadable';

export const LazyEditorTitleAreaBanner = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorTitleAreaBanner" */ './EditorTitleAreaBanner.tsx'
			)
		).EditorTitleAreaBannerErrorBoundary,
});
